/**
 * Download blob as file
 */
export const downloadBlob = (blob: Blob, filename: string) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

/**
 * Handle export with error handling
 */
export const handleExport = async (
  exportFunction: () => Promise<Blob>,
  filename: string,
  onSuccess?: () => void,
  onError?: (error: any) => void
) => {
  try {
    const blob = await exportFunction();
    downloadBlob(blob, filename);
    if (onSuccess) onSuccess();
  } catch (error: any) {
    console.error('Export error:', error);
    if (onError) {
      onError(error);
    } else {
      alert('Dışa aktarma sırasında bir hata oluştu. Lütfen tekrar deneyin.');
    }
  }
};

